module.exports = __webpack_public_path__ + "img/22-1.bb7d8269.png";